import './_style.scss';

import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import warning from '../../../../assets/img/brand/warning.svg';

const motivos = {
  jaRecepcionado:
    'Contrato já recepcionado neste tipo de protocolo. Realize um protocolo de Complemento / Regularização.',
  contratoExclusao:
    'O contrato informado já pertence a um protocolo Principal, é necessário exclui-lo do protocolo para inserir.',
  naoPertence: 'O Contrato informado não pertence a este tipo de protocolo.',
  contemPendencias: 'O Contrato informado contem pendencias em aberto.',
};

const ModalProtocoloInvalido = ({ isOpen, toggle, contratoBloqueado, confirmarExclusao }) => {
  const [numeroContrato, setNumeroContrato] = useState('');
  const [motivoBloqueio, setMotivoBloqueio] = useState('');
  const [showExcluir, setShowExcluir] = useState(false);

  const confirmarExclusaoContrato = () => {
    confirmarExclusao();
  };

  useEffect(() => {
    if (contratoBloqueado.NumeroContrato) {
      setNumeroContrato(contratoBloqueado.NumeroContrato);
      if (contratoBloqueado.Recepcionado) {
        setMotivoBloqueio(motivos.jaRecepcionado);
      } else if (contratoBloqueado.TipoSituacao === 'RECEPCAO') {
        setMotivoBloqueio(motivos.contratoExclusao);
        setShowExcluir(true);
      }
    }
  }, [contratoBloqueado]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-md modal-default">
      <ModalHeader>
        O contrato {numeroContrato} não pode ser inserido neste tipo de protocolo
      </ModalHeader>
      <ModalBody>

        <div className="container-image">
          <img className="alert" src={warning} alt="alerta" />
        </div>
          <p className="text-alert error">{motivoBloqueio}</p>
      </ModalBody>
      <ModalFooter>
        {showExcluir && (
          <Button color="btn btn-primary" className="btn-primary" onClick={confirmarExclusaoContrato}>Excluir</Button>
        )}
        <Button className="btn_success" onClick={toggle}>Fechar</Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalProtocoloInvalido;
